const show1Data =
{
    "id": 1,
    "clientId": 2,
    "showName": "NED",
    "location": "Netherlands",
    "startDate": "2024-11-12 16:08:21.580",
    "endDate": "2024-11-23 16:08:21.580",
    "area": "30 Sqm",
    "area1": 30,
    "type": "A2",
    imageData: [
        {
            title: "Custom Sofa",
            quantity: 3,
            isAdditional: false,
            isRental: false,
            length: "1000mm",
            bredth: "500mm",
            height: "900mm",
            color: "",
            images: [
                { src: "/assets/showImages/custom_sofa5.jpg", alt: "custom sofa" },
                { src: "/assets/showImages/custom_sofa4.jpg", alt: "custom sofa" },
                { src: "/assets/showImages/custom_sofa6.jpg", alt: "custom sofa" },
            ]
        },
        {
            title: "Custom Sofa",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "500mm",
            bredth: "500mm",
            height: "900mm",
            color: "",
            images: [
                { src: "/assets/showImages/custom_sofa1.jpg", alt: "custom sofa" },
                { src: "/assets/showImages/custom_sofa2.jpg", alt: "custom sofa" },
                { src: "/assets/showImages/custom_sofa3.jpg", alt: "custom sofa" },
            ]
        },
        {
            title: "Reception",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "1000mm",
            bredth: "500mm",
            height: "1000mm",
            color: "",
            images: [
                { src: "/assets/showImages/reception1.jpg", alt: "Reception" },
                { src: "/assets/showImages/reception2.jpg", alt: "Reception" },
                { src: "/assets/showImages/reception3.jpg", alt: "Reception" },
                { src: "/assets/showImages/reception4.jpg", alt: "Reception" },
            ]
        },
        {
            title: "A letter",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "",
            bredth: "3500mm",
            height: "3500mm",
            color: "Navy Blue",
            images: [
                { src: "/assets/showImages/A_Letter3.jpg", alt: "A letter" },
                { src: "/assets/showImages/A_Letter4.jpg", alt: "A letter" },
            ]
        },

        {
            title: "Demo Stand",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "1750mm",
            bredth: "1750mm",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/demo_stand1.jpg", alt: "demo stand" },
                { src: "/assets/images/demo_stand3.png", alt: "demo stand" },
            ]
        },
        {
            title: "Catering Station",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "1500mm",
            bredth: "1000mm",
            height: "650mm",
            color: "",
            images: [
                { src: "/assets/showImages/catering_station1.jpg", alt: "catering station" },
                { src: "/assets/showImages/catering_station2.jpg", alt: "catering station" },
            ]
        },
        {
            title: "MockUp Info Stand",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "3600mm",
            bredth: "300mm",
            height: "900mm",
            color: "white",
            images: [
                { src: "/assets/showImages/mockUp1.jpg", alt: "mockup stand" },
                { src: "/assets/images/mockUp4.jpg", alt: "mockup stand" },
            ]
        },

    ]
}

const show2Data =
{
    "id": 2,
    "clientId": 2,
    "showName": "UAS Dusseldorf",
    "location": "Dusseldorf",
    "startDate": "2025-02-18 16:08:21.580",
    "endDate": "2025-02-20 16:08:21.580",
    "area": "37.5 Sqm",
    "area1": 37.5,
    "type": "A2",
    imageData: [
        {
            title: "Custom Sofa",
            quantity: 3,
            isAdditional: false,
            isRental: false,
            length: "1000mm",
            bredth: "500mm",
            height: "900mm",
            color: "Brown",
            images: [
                { src: "/assets/showImages/custom_sofa5.jpg", alt: "custom sofa" },
                { src: "/assets/showImages/custom_sofa4.jpg", alt: "custom sofa" },
                { src: "/assets/showImages/custom_sofa6.jpg", alt: "custom sofa" },
            ]
        },
        {
            title: "Custom Sofa",
            quantity: 1,
            isAdditional: true,
            isRental: false,
            length: "500mm",
            bredth: "500mm",
            height: "900mm",
            color: "",
            images: [
                { src: "/assets/showImages/custom_sofa3.jpg", alt: "custom sofa" },
                { src: "/assets/showImages/custom_sofa1.jpg", alt: "custom sofa" },
                { src: "/assets/showImages/custom_sofa2.jpg", alt: "custom sofa" },
            ]
        },
        {
            title: "Catering Station",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "1500mm",
            bredth: "1000mm",
            height: "650mm",
            color: "",
            images: [
                { src: "/assets/showImages/catering_station1.jpg", alt: "catering station" },
                { src: "/assets/showImages/catering_station2.jpg", alt: "catering station" },
            ]
        },
        {
            title: "Reception",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "1000mm",
            bredth: "500mm",
            height: "1000mm",
            color: "",
            images: [
                { src: "/assets/showImages/reception1.jpg", alt: "Reception" },
                { src: "/assets/showImages/reception2.jpg", alt: "Reception" },
                { src: "/assets/showImages/reception3.jpg", alt: "Reception" },
                { src: "/assets/showImages/reception4.jpg", alt: "Reception" },
            ]
        },
        {
            title: "A letter",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "",
            bredth: "3500mm",
            height: "3500mm",
            color: "",
            images: [
                { src: "/assets/showImages/A_Letter3.jpg", alt: "A letter" },
                { src: "/assets/showImages/A_Letter4.jpg", alt: "A letter" },
            ]
        },



        {
            title: "Bristo Coffee Machine",
            quantity: 1,
            isAdditional: true,
            isRental: false,
            length: "",
            bredth: "",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/bristoCoffeeMachine1.png", alt: "Bristo Coffee Machine" },
                { src: "/assets/showImages/bristoCoffeeMachine2.png", alt: "Bristo Coffee Machine" },
            ]
        },
        {
            title: "Photo frames",
            quantity: 1,
            isAdditional: true,
            isRental: false,
            length: "",
            bredth: "",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/photoFrame1.jpg", alt: "chair Image 1" },
                { src: "/assets/showImages/photoFrame2.jpg", alt: "chair Image 2" },
            ]
        }
    ]
}

const show3Data = {
    "id": 3,
    "clientId": 2,
    "showName": "IMH London",
    "location": "London",
    "startDate": "2025-02-25 16:08:21.580",
    "endDate": "2025-02-27 16:08:21.580",
    "area": "12 Sqm",
    "area1": 12,
    "type": "A1",
    imageData: [

        {
            title: "Reception",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "1000mm",
            bredth: "500mm",
            height: "1000mm",
            color: "",
            images: [
                { src: "/assets/showImages/reception1.jpg", alt: "Reception" },
                { src: "/assets/showImages/reception2.jpg", alt: "Reception" },
                { src: "/assets/showImages/reception3.jpg", alt: "Reception" },
                { src: "/assets/showImages/reception4.jpg", alt: "Reception" },
            ]
        },

        {
            title: "Brochure Stand",
            quantity: 1,
            isAdditional: true,
            isRental: false,
            length: "",
            bredth: "",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/brochure1.webp", alt: "brochure stand" },
                { src: "/assets/showImages/brochure2.webp", alt: "brochure stand" },
            ]
        },
        {
            title: "High Table + 3 Chairs",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "",
            bredth: "",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/Sitting2.jpg", alt: "high table" },
                { src: "/assets/showImages/Sitting.jpg", alt: "high table" },
            ]
        },



    ]
}

const show4Data =
{
    "id": 4,
    "clientId": 2,
    "showName": "MWC",
    "location": "Barcelona",
    "startDate": "2025-03-03 16:08:21.580",
    "endDate": "2025-03-06 16:08:21.580",
    "area": "70 Sqm",
    "area1": 70,
    "type": "A3",
    imageData: [
        {
            title: "Custom Sofa",
            quantity: 2,
            isAdditional: false,
            isRental: true,
            length: "1000mm",
            bredth: "500mm",
            height: "900mm",
            color: "",
            images: [
                { src: "/assets/showImages/sofa1.jpg", alt: "custom sofa" },
                { src: "/assets/showImages/Sofa.jpg", alt: "custom sofa" },
            ]
        },

        {
            title: "Low seating",
            quantity: 3,
            isAdditional: false,
            isRental: true,
            length: "",
            bredth: "",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/Chair.jpg", alt: "chair Image 1" },
                { src: "/assets/showImages/Chair2.jpg", alt: "chair Image 2" },
            ]
        },
        {
            title: "Catering Station",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "1500mm",
            bredth: "1000mm",
            height: "650mm",
            color: "",
            images: [
                { src: "/assets/showImages/catering_station1.jpg", alt: "catering station" },
                { src: "/assets/showImages/catering_station2.jpg", alt: "catering station" },
            ]
        },
        {
            title: "High Table + 3 Chairs",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "",
            bredth: "",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/Sitting2.jpg", alt: "high table" },
                { src: "/assets/showImages/Sitting.jpg", alt: "high table" },
            ]
        },
        {
            title: "Coffee Table",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "",
            bredth: "",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/Table.jpg", alt: "coffee table" },
                { src: "/assets/showImages/table-1.jpg", alt: "coffee table" },
            ]
        },
        {
            title: "Coffee Table",
            quantity: 1,
            isAdditional: true,
            isRental: false,
            length: "",
            bredth: "",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/Table.jpg", alt: "coffee table" },
                { src: "/assets/showImages/table-1.jpg", alt: "coffee table" },
            ]
        },



        {
            title: "Hanging Sign",
            quantity: 1,
            isAdditional: true,
            isRental: false,
            length: "",
            bredth: "",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/Hanging_design.jpg", alt: "Hanging Sign" },
                { src: "/assets/showImages/Hanging_design2.jpg", alt: "Hanging Sign" },
            ]
        },
        {
            title: "3D Logo",
            quantity: 3,
            isAdditional: true,
            isRental: false,
            length: "",
            bredth: "",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/3dLogo2.png", alt: "3d Logo" },
                { src: "/assets/showImages/3dLogo1.png", alt: "3d Logo" },
            ]
        },
        {
            title: "Laminate Flooring",
            quantity: 1,
            isAdditional: true,
            isRental: false,
            length: "",
            bredth: "",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/Floor.jpg", alt: "Floor" },
                { src: "/assets/showImages/Floor2.jpg", alt: "Floor" },
            ]
        },

    ]
}

const show5Data =
{
    "id": 4,
    "clientId": 2,
    "showName": "Sofins",
    "location": "Bordeaux",
    "startDate": "2025-03-03 16:08:21.580",
    "endDate": "2025-03-06 16:08:21.580",
    "area": "90 Sqm",
    "area1": 90,
    "type": "A3",
    imageData: [
        {
            title: "A letter",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "",
            bredth: "3500mm",
            height: "3500mm",
            color: "Navy Blue",
            images: [
                { src: "/assets/showImages/A_Letter3.jpg", alt: "A letter" },
                { src: "/assets/showImages/A_Letter4.jpg", alt: "A letter" },
            ]
        },
        {
            title: "Demo Stand",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "1000mm",
            bredth: "300mm",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/demo.jpg", alt: "demo stand" },
                { src: "/assets/showImages/demo2.jpg", alt: "demo stand" },
            ]
        },
        {
            title: "Demo Stand",
            quantity: 1,
            isAdditional: true,
            isRental: false,
            length: "1000mm",
            bredth: "300mm",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/demo.jpg", alt: "demo stand" },
                { src: "/assets/showImages/demo2.jpg", alt: "demo stand" },
            ]
        },
        {
            title: "Podium-2",
            quantity: 1,
            isAdditional: true,
            isRental: false,
            length: "1750mm",
            bredth: "1750mm",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/podiumMockup1.jpg", alt: "demo stand" },
                { src: "/assets/images/podiumMockup2.jpg", alt: "demo stand" },
            ]
        },
        {
            title: "Podium-1",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "1750mm",
            bredth: "1750mm",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/podiumMockup1.jpg", alt: "demo stand" },
                { src: "/assets/images/podiumMockup2.jpg", alt: "demo stand" },
            ]
        },



        {
            title: "Custom Sofa",
            quantity: 2,
            isAdditional: false,
            isRental: false,
            length: "1000mm",
            bredth: "500mm",
            height: "900mm",
            color: "",
            images: [
                { src: "/assets/showImages/custom_sofa5.jpg", alt: "custom sofa" },
                { src: "/assets/showImages/custom_sofa4.jpg", alt: "custom sofa" },
                { src: "/assets/showImages/custom_sofa6.jpg", alt: "custom sofa" },
            ]
        },
        {
            title: "Custom Sofa",
            quantity: 2,
            isAdditional: true,
            isRental: false,
            length: "1000mm",
            bredth: "500mm",
            height: "900mm",
            color: "",
            images: [
                { src: "/assets/showImages/custom_sofa5.jpg", alt: "custom sofa" },
                { src: "/assets/showImages/custom_sofa4.jpg", alt: "custom sofa" },
                { src: "/assets/showImages/custom_sofa6.jpg", alt: "custom sofa" },
            ]
        },
        {
            title: "Custom Sofa",
            quantity: 1,
            isAdditional: true,
            isRental: false,
            length: "500mm",
            bredth: "500mm",
            height: "900mm",
            color: "",
            images: [
                { src: "/assets/showImages/custom_sofa1.jpg", alt: "custom sofa" },
                { src: "/assets/showImages/custom_sofa2.jpg", alt: "custom sofa" },
                { src: "/assets/showImages/custom_sofa3.jpg", alt: "custom sofa" },
            ]
        },
        {
            title: "Catering Station",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "1500mm",
            bredth: "1000mm",
            height: "650mm",
            color: "",
            images: [
                { src: "/assets/showImages/catering_station1.jpg", alt: "catering station" },
                { src: "/assets/showImages/catering_station2.jpg", alt: "catering station" },
            ]
        },
        {
            title: "Meeting Room Table",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "3000mm",
            bredth: "800mm",
            height: "750mm",
            color: "",
            images: [
                { src: "/assets/showImages/meetingTable2.jpg", alt: "Meeting Table" },
                { src: "/assets/showImages/MeetingTable.jpg", alt: "Meeting Table" },
            ]
        },
        {
            title: "Meeting Room Cabinet",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "",
            bredth: "",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/meetingCabinet.jpg", alt: "Meeting Cabinet" },
                { src: "/assets/showImages/meetingCabinet.jpg", alt: "Meeting Cabinet" },
            ]
        },
        {
            title: "Reception",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "1000mm",
            bredth: "500mm",
            height: "1000mm",
            color: "",
            images: [
                { src: "/assets/showImages/reception1.jpg", alt: "Reception" },
                { src: "/assets/showImages/reception2.jpg", alt: "Reception" },
                { src: "/assets/showImages/reception3.jpg", alt: "Reception" },
                { src: "/assets/showImages/reception4.jpg", alt: "Reception" },
            ]
        },
        {
            title: "Coffee Table",
            quantity: 2,
            isAdditional: true,
            isRental: false,
            length: "",
            bredth: "",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/Table.jpg", alt: "coffee table" },
                { src: "/assets/showImages/table-1.jpg", alt: "coffee table" },
            ]
        },
        {
            title: "Coffee Table",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "",
            bredth: "",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/Table.jpg", alt: "coffee table" },
                { src: "/assets/showImages/table-1.jpg", alt: "coffee table" },
            ]
        },
        {
            title: "Puffs",
            quantity: 6,
            isAdditional: true,
            isRental: false,
            length: "",
            bredth: "",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/puff1.jpg", alt: "puff" },
                { src: "/assets/showImages/puff2.jpg", alt: "puff" },
            ]
        },

    ]
}

const show6Data =
{
    "id": 4,
    "clientId": 2,
    "showName": "Sofins (outdoor)",
    "location": "Bordeaux",
    "startDate": "2025-04-01 16:08:21.580",
    "endDate": "2025-04-03 16:08:21.580",
    "area": "800 Sqm",
    "type": "A3",
    imageData: [
        {
            title: "A letter",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "",
            bredth: "3500mm",
            height: "3500mm",
            color: "Navy Blue",
            images: [
                { src: "/assets/showImages/A_Letter3.jpg", alt: "A letter" },
                { src: "/assets/showImages/A_Letter4.jpg", alt: "A letter" },
            ]
        },
        {
            title: "Demo Stand",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "1750mm",
            bredth: "1750mm",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/demo_stand1.jpg", alt: "demo stand" },
                { src: "/assets/images/demo_stand3.png", alt: "demo stand" },
            ]
        },

        {
            title: "Custom Sofa",
            quantity: 3,
            isAdditional: false,
            isRental: false,
            length: "1000mm",
            bredth: "500mm",
            height: "900mm",
            color: "",
            images: [
                { src: "/assets/showImages/custom_sofa5.jpg", alt: "custom sofa" },
                { src: "/assets/showImages/custom_sofa4.jpg", alt: "custom sofa" },
                { src: "/assets/showImages/custom_sofa6.jpg", alt: "custom sofa" },
            ]
        },
        {
            title: "Custom Sofa",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "500mm",
            bredth: "500mm",
            height: "900mm",
            color: "",
            images: [
                { src: "/assets/showImages/custom_sofa1.jpg", alt: "custom sofa" },
                { src: "/assets/showImages/custom_sofa2.jpg", alt: "custom sofa" },
                { src: "/assets/showImages/custom_sofa3.jpg", alt: "custom sofa" },
            ]
        },
        {
            title: "Catering Station",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "1500mm",
            bredth: "1000mm",
            height: "650mm",
            color: "",
            images: [
                { src: "/assets/showImages/catering_station1.jpg", alt: "catering station" },
                { src: "/assets/showImages/catering_station2.jpg", alt: "catering station" },
            ]
        },
        {
            title: "Reception",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "1000mm",
            bredth: "500mm",
            height: "1000mm",
            color: "",
            images: [
                { src: "/assets/showImages/reception1.jpg", alt: "Reception" },
                { src: "/assets/showImages/reception2.jpg", alt: "Reception" },
                { src: "/assets/showImages/reception3.jpg", alt: "Reception" },
                { src: "/assets/showImages/reception4.jpg", alt: "Reception" },
            ]
        },
        {
            title: "Coffee Table",
            quantity: 1,
            isAdditional: true,
            isRental: false,
            length: "",
            bredth: "",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/Table.jpg", alt: "coffee table" },
                { src: "/assets/showImages/table-1.jpg", alt: "coffee table" },
            ]
        },

    ]
}

const show7Data =
{
    "id": 4,
    "clientId": 2,
    "showName": "DSEI JAPAN 2025",
    "location": "Makuhari Messe, Chiba",
    "startDate": "2025-05-21 16:08:21.580",
    "endDate": "2025-05-23 16:08:21.580",
    "area": "21 Sqm",
    "area1": 21,
    "type": "A2",
    imageData: [


    ]
}

const show8Data =
{
    "id": 4,
    "clientId": 2,
    "showName": "Passenger Terminal Expo",
    "location": "Madrid, Spain",
    "startDate": "2025-04-08 16:08:21.580",
    "endDate": "2025-04-10 16:08:21.580",
    "area": "20 Sqm",
    "area1": 20,
    "type": "A1",
    imageData: [


    ]
}

const contractAssets =
{

    imageData: [
        {
            title: "A letter",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "2000mm",
            bredth: "",
            height: "3400mm",
            color: "Navy Blue",
            images: [
                { src: "/assets/showImages/A_Letter3.jpg", alt: "A letter" },
                { src: "/assets/showImages/A_Letter4.jpg", alt: "A letter" },
            ]
        },
        {
            title: "Podium",
            quantity: 1,
            isAdditional: true,
            isRental: false,
            length: "2100mm",
            bredth: "100mm",
            height: "2100mm",
            color: "",
            images: [
                { src: "/assets/showImages/podiumMockup1.jpg", alt: "demo stand" },
                { src: "/assets/images/podiumMockup2.jpg", alt: "demo stand" },
            ]
        },

        {
            title: "Demo Stand",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "1750mm",
            bredth: "1750mm",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/demo.jpg", alt: "demo stand" },
                { src: "/assets/images/demo2.jpg", alt: "demo stand" },
            ]
        },
        {
            title: "Custom Sofa",
            quantity: 3,
            isAdditional: false,
            isRental: false,
            length: "1000mm",
            bredth: "500mm",
            height: "1000mm",
            color: "",
            images: [
                { src: "/assets/showImages/custom_sofa5.jpg", alt: "custom sofa" },
                { src: "/assets/showImages/custom_sofa4.jpg", alt: "custom sofa" },
                { src: "/assets/showImages/custom_sofa6.jpg", alt: "custom sofa" },
            ]
        },
        {
            title: "Custom Sofa",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "500mm",
            bredth: "500mm",
            height: "900mm",
            color: "",
            images: [
                { src: "/assets/showImages/custom_sofa1.jpg", alt: "custom sofa" },
                { src: "/assets/showImages/custom_sofa2.jpg", alt: "custom sofa" },
                { src: "/assets/showImages/custom_sofa3.jpg", alt: "custom sofa" },
            ]
        },

        {
            title: "Meeting Room Cabinet",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "",
            bredth: "",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/meetingCabinet.jpg", alt: "Meeting Cabinet" },
                { src: "/assets/showImages/meetingCabinet.jpg", alt: "Meeting Cabinet" },
            ]
        },
        {
            title: "Reception",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "1000mm",
            bredth: "500mm",
            height: "1000mm",
            color: "",
            images: [
                { src: "/assets/showImages/reception1.jpg", alt: "Reception" },
                { src: "/assets/showImages/reception2.jpg", alt: "Reception" },
                { src: "/assets/showImages/reception3.jpg", alt: "Reception" },
                { src: "/assets/showImages/reception4.jpg", alt: "Reception" },
            ]
        },
        {
            title: "MockUp Info Stand",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "900mm",
            bredth: "300mm",
            height: "3600mm",
            color: "white",
            images: [
                { src: "/assets/showImages/mockUp1.jpg", alt: "mockup stand" },
                { src: "/assets/images/mockUp4.jpg", alt: "mockup stand" },
            ]
        },
        {
            title: "Meeting Room Table",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "900mm",
            bredth: "300mm",
            height: "3600mm",
            color: "white",
            images: [
                { src: "/assets/showImages/meetingCabinet.jpg", alt: "mockup stand" },
                { src: "/assets/showImages/MeetingTable.jpg", alt: "mockup stand" },
            ]
        },


    ]
}

const A1ContractualData = {
    minArea: 9,
    maxArea: 20,
    imageData: [
        {
            title: "High Table + 3 Chairs",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "",
            bredth: "",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/Sitting2.jpg", alt: "high table" },
                { src: "/assets/showImages/Sitting.jpg", alt: "high table" },
            ]
        },
    ]
}

const A1AdditionalAssets = {
    minArea: 1,
    maxArea: 20,
    imageData: [
        {
            title: "High Table + 3 Chairs",
            quantity: "n",
            isAdditional: false,
            isRental: false,
            length: "",
            bredth: "",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/Sitting2.jpg", alt: "high table" },
                { src: "/assets/showImages/Sitting.jpg", alt: "high table" },
            ]
        },
        {
            title: "A letter",
            quantity: "n",
            isAdditional: false,
            isRental: false,
            length: "2000mm",
            bredth: "",
            height: "3400mm",
            color: "Navy Blue",
            images: [
                { src: "/assets/showImages/A_Letter3.jpg", alt: "A letter" },
                { src: "/assets/showImages/A_Letter4.jpg", alt: "A letter" },
            ]
        },
        {
            title: "Reception",
            quantity: "n",
            isAdditional: false,
            isRental: false,
            length: "1000mm",
            bredth: "500mm",
            height: "1000mm",
            color: "",
            images: [
                { src: "/assets/showImages/reception1.jpg", alt: "Reception" },
                { src: "/assets/showImages/reception2.jpg", alt: "Reception" },
                { src: "/assets/showImages/reception3.jpg", alt: "Reception" },
                { src: "/assets/showImages/reception4.jpg", alt: "Reception" },
            ]
        },
        {
            title: "Demo Stand",
            quantity: "n",
            isAdditional: false,
            isRental: false,
            length: "1750mm",
            bredth: "1750mm",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/demo.jpg", alt: "demo stand" },
                { src: "/assets/images/demo2.jpg", alt: "demo stand" },
            ]
        },
        {
            title: "Puffs",
            quantity: "n",
            isAdditional: true,
            isRental: false,
            length: "",
            bredth: "",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/puff1.jpg", alt: "puff" },
                { src: "/assets/showImages/puff2.jpg", alt: "puff" },
            ]
        },
        {
            title: "Photo frames",
            quantity: "n",
            isAdditional: true,
            isRental: false,
            length: "",
            bredth: "",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/photoFrame1.jpg", alt: "chair Image 1" },
                { src: "/assets/showImages/photoFrame2.jpg", alt: "chair Image 2" },
            ]
        },
        {
            title: "Laminate Flooring",
            quantity: "n",
            isAdditional: true,
            isRental: false,
            length: "",
            bredth: "",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/Floor.jpg", alt: "Floor" },
                { src: "/assets/showImages/Floor2.jpg", alt: "Floor" },
            ]
        },
    ]
}

const A2ContractualData = {
    minArea: 21,
    maxArea: 55,
    imageData: [
        {
            title: "High Table + 3 Chairs",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "",
            bredth: "",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/Sitting2.jpg", alt: "high table" },
                { src: "/assets/showImages/Sitting.jpg", alt: "high table" },
            ]
        },
        {
            title: "A letter",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "2000mm",
            bredth: "",
            height: "3400mm",
            color: "Navy Blue",
            images: [
                { src: "/assets/showImages/A_Letter3.jpg", alt: "A letter" },
                { src: "/assets/showImages/A_Letter4.jpg", alt: "A letter" },
            ]
        },
        {
            title: "Custom Sofa",
            quantity: 3,
            isAdditional: false,
            isRental: false,
            length: "1000mm",
            bredth: "500mm",
            height: "1000mm",
            color: "",
            images: [
                { src: "/assets/showImages/custom_sofa5.jpg", alt: "custom sofa" },
                { src: "/assets/showImages/custom_sofa4.jpg", alt: "custom sofa" },
                { src: "/assets/showImages/custom_sofa6.jpg", alt: "custom sofa" },
            ]
        },
        {
            title: "Custom Sofa",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "500mm",
            bredth: "500mm",
            height: "900mm",
            color: "",
            images: [
                { src: "/assets/showImages/custom_sofa1.jpg", alt: "custom sofa" },
                { src: "/assets/showImages/custom_sofa2.jpg", alt: "custom sofa" },
                { src: "/assets/showImages/custom_sofa3.jpg", alt: "custom sofa" },
            ]
        },
        {
            title: "Podium",
            quantity: 1,
            isAdditional: true,
            isRental: false,
            length: "2100mm",
            bredth: "100mm",
            height: "2100mm",
            color: "",
            images: [
                { src: "/assets/showImages/podiumMockup1.jpg", alt: "demo stand" },
                { src: "/assets/images/podiumMockup2.jpg", alt: "demo stand" },
            ]
        },
    ]
}

const A2AdditionalAssets = {
    minArea: 21,
    maxArea: 55,
    imageData: [
        {
            title: "High Table + 3 Chairs",
            quantity: "n",
            isAdditional: false,
            isRental: false,
            length: "",
            bredth: "",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/Sitting2.jpg", alt: "high table" },
                { src: "/assets/showImages/Sitting.jpg", alt: "high table" },
            ]
        },
        {
            title: "Reception",
            quantity: "n",
            isAdditional: false,
            isRental: false,
            length: "1000mm",
            bredth: "500mm",
            height: "1000mm",
            color: "",
            images: [
                { src: "/assets/showImages/reception1.jpg", alt: "Reception" },
                { src: "/assets/showImages/reception2.jpg", alt: "Reception" },
                { src: "/assets/showImages/reception3.jpg", alt: "Reception" },
                { src: "/assets/showImages/reception4.jpg", alt: "Reception" },
            ]
        },
        {
            title: "Demo Stand",
            quantity: "n",
            isAdditional: false,
            isRental: false,
            length: "1750mm",
            bredth: "1750mm",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/demo.jpg", alt: "demo stand" },
                { src: "/assets/images/demo2.jpg", alt: "demo stand" },
            ]
        },
        {
            title: "Catering Station",
            quantity: "n",
            isAdditional: false,
            isRental: false,
            length: "1500mm",
            bredth: "1000mm",
            height: "650mm",
            color: "",
            images: [
                { src: "/assets/showImages/catering_station1.jpg", alt: "catering station" },
                { src: "/assets/showImages/catering_station2.jpg", alt: "catering station" },
            ]
        },
        {
            title: "Puffs",
            quantity: "n",
            isAdditional: true,
            isRental: false,
            length: "",
            bredth: "",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/puff1.jpg", alt: "puff" },
                { src: "/assets/showImages/puff2.jpg", alt: "puff" },
            ]
        },
        {
            title: "Photo frames",
            quantity: "n",
            isAdditional: true,
            isRental: false,
            length: "",
            bredth: "",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/photoFrame1.jpg", alt: "chair Image 1" },
                { src: "/assets/showImages/photoFrame2.jpg", alt: "chair Image 2" },
            ]
        },
        {
            title: "Laminate Flooring",
            quantity: "n",
            isAdditional: true,
            isRental: false,
            length: "",
            bredth: "",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/Floor.jpg", alt: "Floor" },
                { src: "/assets/showImages/Floor2.jpg", alt: "Floor" },
            ]
        },
        {
            title: "Meeting Room Cabinet",
            quantity: "n",
            isAdditional: false,
            isRental: false,
            length: "",
            bredth: "",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/meetingCabinet.jpg", alt: "Meeting Cabinet" },
                { src: "/assets/showImages/meetingCabinet.jpg", alt: "Meeting Cabinet" },
            ]
        },
        {
            title: "Meeting Room Table",
            quantity: "n",
            isAdditional: false,
            isRental: false,
            length: "900mm",
            bredth: "300mm",
            height: "3600mm",
            color: "white",
            images: [
                { src: "/assets/showImages/meetingTable2.jpg", alt: "mockup stand" },
                { src: "/assets/showImages/MeetingTable.jpg", alt: "mockup stand" },
            ]
        },
        {
            title: "MockUp Info Stand",
            quantity: "n",
            isAdditional: false,
            isRental: false,
            length: "3600mm",
            bredth: "300mm",
            height: "900mm",
            color: "white",
            images: [
                { src: "/assets/showImages/mockUp1.jpg", alt: "mockup stand" },
                { src: "/assets/images/mockUp4.jpg", alt: "mockup stand" },
            ]
        },
        {
            title: "Hanging Sign",
            quantity: "n",
            isAdditional: true,
            isRental: false,
            length: "",
            bredth: "",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/Hanging_design.jpg", alt: "Hanging Sign" },
                { src: "/assets/showImages/Hanging_design2.jpg", alt: "Hanging Sign" },
            ]
        },
        {
            title: "3D Logo",
            quantity: 3,
            isAdditional: true,
            isRental: false,
            length: "",
            bredth: "",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/3dLogo2.png", alt: "3d Logo" },
                { src: "/assets/showImages/3dLogo1.png", alt: "3d Logo" },
            ]
        },
    ]
}

const A3ContractualData = {
    minArea: 56,
    maxArea: 1000,
    imageData: [
        {
            title: "High Table + 3 Chairs",
            quantity: "n",
            isAdditional: false,
            isRental: false,
            length: "",
            bredth: "",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/Sitting2.jpg", alt: "high table" },
                { src: "/assets/showImages/Sitting.jpg", alt: "high table" },
            ]
        },
        {
            title: "A letter",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "2000mm",
            bredth: "",
            height: "3400mm",
            color: "Navy Blue",
            images: [
                { src: "/assets/showImages/A_Letter3.jpg", alt: "A letter" },
                { src: "/assets/showImages/A_Letter4.jpg", alt: "A letter" },
            ]
        },
        {
            title: "Podium",
            quantity: 1,
            isAdditional: true,
            isRental: false,
            length: "2100mm",
            bredth: "100mm",
            height: "2100mm",
            color: "",
            images: [
                { src: "/assets/showImages/podiumMockup1.jpg", alt: "demo stand" },
                { src: "/assets/images/podiumMockup2.jpg", alt: "demo stand" },
            ]
        },
        {
            title: "Demo Stand",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "1750mm",
            bredth: "1750mm",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/demo.jpg", alt: "demo stand" },
                { src: "/assets/images/demo2.jpg", alt: "demo stand" },
            ]
        },
        {
            title: "Meeting Room Cabinet",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "",
            bredth: "",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/meetingCabinet.jpg", alt: "Meeting Cabinet" },
                { src: "/assets/showImages/meetingCabinet.jpg", alt: "Meeting Cabinet" },
            ]
        },
        {
            title: "Meeting Room Table",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "900mm",
            bredth: "300mm",
            height: "3600mm",
            color: "white",
            images: [
                { src: "/assets/showImages/meetingCabinet.jpg", alt: "mockup stand" },
                { src: "/assets/showImages/MeetingTable.jpg", alt: "mockup stand" },
            ]
        },
        {
            title: "Custom Sofa",
            quantity: 3,
            isAdditional: false,
            isRental: false,
            length: "1000mm",
            bredth: "500mm",
            height: "1000mm",
            color: "",
            images: [
                { src: "/assets/showImages/custom_sofa5.jpg", alt: "custom sofa" },
                { src: "/assets/showImages/custom_sofa4.jpg", alt: "custom sofa" },
                { src: "/assets/showImages/custom_sofa6.jpg", alt: "custom sofa" },
            ]
        },
        {
            title: "Custom Sofa",
            quantity: 1,
            isAdditional: false,
            isRental: false,
            length: "500mm",
            bredth: "500mm",
            height: "900mm",
            color: "",
            images: [
                { src: "/assets/showImages/custom_sofa1.jpg", alt: "custom sofa" },
                { src: "/assets/showImages/custom_sofa2.jpg", alt: "custom sofa" },
                { src: "/assets/showImages/custom_sofa3.jpg", alt: "custom sofa" },
            ]
        },
    ]
}

const A3AdditionalAssets = {
    minArea: 56,
    maxArea: 1000,
    imageData: [
        {
            title: "High Table + 3 Chairs",
            quantity: "n",
            isAdditional: false,
            isRental: false,
            length: "",
            bredth: "",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/Sitting2.jpg", alt: "high table" },
                { src: "/assets/showImages/Sitting.jpg", alt: "high table" },
            ]
        },
        {
            title: "Demo Stand",
            quantity: "n",
            isAdditional: false,
            isRental: false,
            length: "1750mm",
            bredth: "1750mm",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/demo.jpg", alt: "demo stand" },
                { src: "/assets/images/demo2.jpg", alt: "demo stand" },
            ]
        },
        {
            title: "Puffs",
            quantity: "n",
            isAdditional: true,
            isRental: false,
            length: "",
            bredth: "",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/puff1.jpg", alt: "puff" },
                { src: "/assets/showImages/puff2.jpg", alt: "puff" },
            ]
        },
        {
            title: "Photo frames",
            quantity: "n",
            isAdditional: true,
            isRental: false,
            length: "",
            bredth: "",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/photoFrame1.jpg", alt: "chair Image 1" },
                { src: "/assets/showImages/photoFrame2.jpg", alt: "chair Image 2" },
            ]
        },
        {
            title: "Laminate Flooring",
            quantity: "n",
            isAdditional: true,
            isRental: false,
            length: "",
            bredth: "",
            height: "",
            color: "",
            images: [
                { src: "/assets/showImages/Floor.jpg", alt: "Floor" },
                { src: "/assets/showImages/Floor2.jpg", alt: "Floor" },
            ]
        },
    ]
}



export { show1Data, show2Data, show3Data, show4Data, show5Data, show6Data, contractAssets, show7Data, A1ContractualData, A1AdditionalAssets, A2ContractualData, A2AdditionalAssets, A3ContractualData, A3AdditionalAssets, show8Data }
